// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"85":"e89b9fa9","350":"d2a50ce5","533":"63f414fa","548":"af26edcc","721":"9114e46c","786":"bcfe49f5","925":"a69e1f2f"}[chunkId] + ".js";
};